import * as React from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import { Canvas } from 'common/report/canvas';
type CanvasViewProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
  canvasId: number;
  onError: (error: Error) => void;
};
export const CanvasView: React.FC<CanvasViewProps> = props => {
  return <ReactFlowProvider data-sentry-element="ReactFlowProvider" data-sentry-component="CanvasView" data-sentry-source-file="index.tsx">
      <Canvas projectId={props.projectId} workspaceId={props.workspaceId} userId={props.userId} canvasId={props.canvasId} onError={props.onError} data-sentry-element="Canvas" data-sentry-source-file="index.tsx" />
    </ReactFlowProvider>;
};